export default __webpack_public_path__ + "static/media/liverpool.0284eecb.svg";